import icblast from '@infu/icblast';
const ic = icblast();

export default ic;
